import { match as c } from "ts-pattern";
import { c as a } from "./strings-Bu8_UcAh.js";
import { colors as n } from "@silversea-ssc/design-system-tokens";
const t = "Backgrounds-module_background-white__i8Rqm",
  d = "Backgrounds-module_background-titanium__68gGY",
  e = "Backgrounds-module_background-titanium-dark__QnmO1",
  k = "Backgrounds-module_background-neutral01__EAoAX",
  g = "Backgrounds-module_background-neutral05__KXFUW",
  l = "Backgrounds-module_background-neutral10__LjJz7",
  s = "Backgrounds-module_background-neutral15__gCoHb",
  b = "Backgrounds-module_background-neutral35__AcZNI",
  p = "Backgrounds-module_background-neutral60__V57eE",
  _ = "Backgrounds-module_background-transparent__GzCHR",
  i = "Backgrounds-module_background-product-type-color01__Bc5Az",
  m = "Backgrounds-module_background-product-type-color02__pd6ER",
  y = "Backgrounds-module_background-product-type-color03__H3Z2L",
  T = "Backgrounds-module_background-product-type-color04__diLcT",
  u = {
    backgroundWhite: t,
    backgroundTitanium: d,
    backgroundTitaniumDark: e,
    backgroundNeutral01: k,
    backgroundNeutral05: g,
    backgroundNeutral10: l,
    backgroundNeutral15: s,
    backgroundNeutral35: b,
    backgroundNeutral60: p,
    backgroundTransparent: _,
    backgroundProductTypeColor01: i,
    backgroundProductTypeColor02: m,
    backgroundProductTypeColor03: y,
    backgroundProductTypeColor04: T
  },
  h = o => {
    if (!o) return u.backgroundTransparent;
    const r = "background".concat(a(o));
    return u[r];
  },
  P = o => c(o).with("productTypeColor01", () => "var(--product-type-color-01)").with("productTypeColor02", () => "var(--product-type-color-02)").with("productTypeColor03", () => "var(--product-type-color-03)").with("productTypeColor04", () => "var(--product-type-color-04)").with("transparent", () => "transparent").otherwise(r => n[r]);
export { P as a, h as c };